import { BaseElement, defineElement } from '@webtides/element-js';

/**
 * @property {string} filterName
 * @property {array} categories
 */
export default class PageTeasersFilterElement extends BaseElement {
    properties() {
        return {
            filterName: 'filter',
            categories: {},
        };
    }

    connected() {
        // find all categories and options + option names
        this.querySelectorAll('input[type=checkbox]').forEach((input) => {
            const category = input.dataset['category'];
            const option = input.dataset['option'];
            if (!category) return;
            if (!this.categories[category]) {
                this.categories[category] = {};
            }
            this.categories[category][option] = input.checked;
        });

        this.dispatch(
            'init-categories',
            {
                categories: this.categories,
                selectedCategories: this.selectedCategories,
                filteredCategories: this.filteredCategories,
            },
            true,
            true,
            true,
        );
    }

    events() {
        return {
            input: {
                change: (e) => {
                    const input = e.target;
                    if (input.hasAttribute('data-clear-filter')) {
                        return;
                    }
                    const category = input.dataset['category'];
                    const option = input.dataset['option'];
                    this.categories[category][option] = input.checked;
                    this.categoriesChanged();
                    this.requestUpdate();
                },
            },
            '[data-clear-filter]': {
                click: (e) => {
                    const clearInput = e.target;
                    const category = clearInput.getAttribute('data-clear-filter');

                    this.clearFilters(category !== '' ? category : undefined);
                },
            },
        };
    }

    get selectedCategories() {
        const selectedCategories = [];

        Object.keys(this.categories).forEach((category) => {
            const options = this.categories[category];
            Object.keys(options).forEach((option) => {
                const checked = this.categories[category][option];
                if (checked) selectedCategories.push({ category, option });
            });
        });

        return selectedCategories;
    }

    get filteredCategories() {
        const filteredCategories = {};

        Object.keys(this.categories).forEach((category) => {
            filteredCategories[category] = [];
            Object.keys(this.categories[category]).forEach((option) => {
                const checked = this.categories[category][option];
                if (checked) filteredCategories[category].push(option);
            });
        });

        return filteredCategories;
    }

    update() {
        this.updateInputs();
        super.update();
    }

    categoriesChanged() {
        this.dispatch(
            'select-categories',
            {
                categories: this.categories,
                selectedCategories: this.selectedCategories,
                filteredCategories: this.filteredCategories,
            },
            true,
            true,
            true,
        );
    }

    clearFilters(category = undefined) {
        if (category) {
            // only clear category
            const options = this.categories[category];
            Object.keys(options).forEach((option) => {
                this.categories[category][option] = false;
            });
        } else {
            // clear all categories
            Object.keys(this.categories).forEach((category) => {
                const options = this.categories[category];
                Object.keys(options).forEach((option) => {
                    this.categories[category][option] = false;
                });
            });
        }

        this.categoriesChanged();
        this.requestUpdate();
    }

    updateInputs() {
        Object.keys(this.categories).forEach((category) => {
            const options = this.categories[category];
            Object.keys(options).forEach((option) => {
                const checked = this.filteredCategories[category].includes(option);
                this.categories[category][option] = checked;
                const input = this.querySelector(`[data-category="${category}"][data-option="${option}"]`);
                input.checked = checked;
            });
        });

        const clearInputs = this.querySelectorAll('[data-clear-filter]');
        for (const clearInput of clearInputs) {
            const category = clearInput.getAttribute('data-clear-filter');
            if (category) {
                const hasSelected = this.filteredCategories[category].length > 0;
                clearInput.checked = !hasSelected;
            }
        }
    }
}

defineElement('page-teasers-filter-element', PageTeasersFilterElement);
